/**
 * Created by mac on 3/3/24
 */

RestoreProgressButton.OverlappingNodes = RestoreProgressButton.OverlappingNodes.concat(["YatzyFieldView", "DicesView", "RollButtonView", "ResultsBarView", "LevelMasteryView"]);
